<script context='module'>
  export const LINK = 'link';
  export const TEXT = 'text';
</script>

<script>
  export let href;
  export let external = false;
  export let target = external ? '_blank' : undefined;
  export let rel = external ? 'noreferrer' : undefined;
  export let appearance = LINK;
  export let testid = undefined;
</script>

<a
  class={appearance}
  {href}
  {target}
  {rel}
  data-cy={testid}
  {...$$restProps}
>
  <slot />
</a>

<style lang="postcss">
  a {
    color: var(--Link--color, var(--color--link));
    text-decoration: var(--Link--text-decoration, underline);
    transition: color var(--duration--fast) var(--ease--on-screen);

    &:hover {
      color: var(--Link--color, var(--color--link--hover));
    }

    &:active {
      color: var(--Link--color, var(--color--link--active));
    }

    &:visited {
      color: var(--Link--color, var(--color--link--visited));
    }
  }

  .text {
    color: var(--Text--color, var(--color--default--text));
    --Link--text-decoration: none;

    &:hover, &:active, &:visited {
      color: var(--Text--color, var(--Link--color));
    }
  }
</style>
